import { MultiballBooster } from "../../cumulative_boosters/boosters/multiball_booster.js";
import { InfiniteBallsBooster } from "../../cumulative_boosters/boosters/infinite_balls_booster.js";

export enum BuyBoosterType
{
  Firework,
  FiveBalls,
  BigBall,
  InfiniteShots,
}

export type BuyBoosterRewardSource = "game_start" | "in_game" | "debug" | "unknown";

export function getDefaultBoosterEffectValue( booster_type: BuyBoosterType ): number | null
{
  switch ( booster_type )
  {
    case BuyBoosterType.FiveBalls:
      return MultiballBooster.DEFAULT_BALL_COUNT;
    case BuyBoosterType.InfiniteShots:
      return InfiniteBallsBooster.DEFAULT_DURATION_SECONDS;
    default:
      return null;
  }
}

export function getBoosterTextVariableParams(
  booster_type: BuyBoosterType,
  effect_value?: number | null
): string[]
{
  const value = effect_value ?? getDefaultBoosterEffectValue( booster_type );
  return value === null ? [] : [ String( value ) ];
}
